module.exports = __webpack_public_path__ + "55ca4dc2b1ae73eb9af4124219e22c21.svg";